import React, { Component } from 'react';
import Sidenavigation from '../layouts/Sidenavigation';
import Topnavigation from '../layouts/Topnavigation';
import Addcategorycontent from '../sections/Addproduct/Addcategorycontent'
import Quickbar from '../layouts/Quickbar';

class Addcategory extends Component {
    render() {
        return (
            <div className="ms-body ms-aside-left-open ms-primary-theme ms-has-quickbar">
                <Sidenavigation />
                <main className="body-content">
                    <Topnavigation />
                    <Addcategorycontent/>
                </main>
                <Quickbar />
            </div>
        );
    }
}

export default Addcategory;